import { call, put, takeLatest } from "redux-saga/effects";
import { getAudioSuccess, getAudioFailure, getAudioStart } from "../reducer";
import { networkErrorHandler } from "../../../utils/errorHandlers";
import { httpGetAudio } from "../../../services/audio";

function* getAudio({ payload }) {
  const { id } = payload;
  const response = yield call(httpGetAudio, id);
  const { success, raw, message } = response;

  if (success) {
    yield put(getAudioSuccess(raw));
  } else {
    yield put(getAudioFailure(message || raw?.error));
    networkErrorHandler(response?.statusCode, message || raw?.error);
  }
}

export default function* onGetAudio() {
  yield takeLatest(getAudioStart.type, getAudio);
}
